import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import 'angular-formly'
const gridId = Symbol("main.contract.process.template.grid");
export class ProcessTemplateController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
    "$compile",
  ];
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  templateId = {};
  processTemplates!: any;
  

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly recordGridViewService: RecordGridViewService,
    $compile: ICompileService,
  ) {
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/process/template" 
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    

    this.columns = [

      
      columnDefinitionService.getLinkColDef({
        headerName: "edit",
        iconClass: "fa fa-pencil text-primary",
        colId: "edit",
        stateExpression: "main.contract.process.template.edit({ templateId: data.Id})",
        requiresPermission: "templateEdit",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
        hide: true,
      }),
      
      columnDefinitionService.getStringColDef({
        field: "Type",
        header: "Type",
      }),
      columnDefinitionService.getStringColDef({
        field: "Action",
        header: "Action",
      }),
      columnDefinitionService.getStringColDef({
        field: "MailSubject",
        header: "Subject",
      }),
      columnDefinitionService.getStringColDef({
        field: "MailBody",
        header: "Body",
      }),
      
    ];
  }

  $onInit(): void {
  }
}
